import { PermissionsType } from '@/common/permissionsConst';
import StrategySimulation from '.';

const routes = [
  {
    path: '/microgrids/strategy/simulation',
    element: <StrategySimulation />,
    permission: PermissionsType.P_MICROGRID_POLICY_SIMULATION,
  },
];

export default routes;
